import { faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from '@ui';
import { PaymentStatus as MolliePaymentStatus } from 'components/Mollie/types';
import { PaymentStatusComponent } from '.';

interface Props {
    paymentId: string;
    paymentStatus: MolliePaymentStatus;
}
const renderPaymentStatus = (status: MolliePaymentStatus) => {
    switch (status) {
        case 'canceled':
            return 'error';

        case 'waiting':
        case 'pending':
            return 'warning';

        case 'paid':
            return 'success';

        default:
            return 'light';
    }
};

export const PaymentStatusButton = ({ paymentId, paymentStatus }: Props) => {
    return (
        <Tooltip autoPlacement tooltip={<PaymentStatusComponent paymentId={paymentId} />} trigger="hover">
            <Button
                size={'sm'}
                className="tw-items-center tw-justify-center tw-text-center"
                color={renderPaymentStatus(paymentStatus)}
            >
                <FontAwesomeIcon icon={faMoneyBill} />
            </Button>
        </Tooltip>
    );
};

export default PaymentStatusButton;
